var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrgChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_2521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25 7.51666V12.5167H1.25L1.25 7.51666H6.25ZM5.38333 11.6833V8.35H2.05V11.6833H5.38333Z",
    fill: "#404349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 7.51666V12.5167H13.75V7.51666H18.75ZM17.8833 11.6833V8.35H14.55V11.6833H17.8833Z",
    fill: "#404349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.81641 10.45V9.61668H14.1497V10.45H5.81641Z",
    fill: "#404349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1498 2.08335V2.91668H12.0498C11.6165 2.91668 11.1831 3.08335 10.8831 3.41668C10.5831 3.71668 10.3831 4.15001 10.3831 4.58335V15.4167C10.3831 15.85 10.5498 16.2833 10.8831 16.5833C11.1831 16.8833 11.6165 17.0833 12.0498 17.0833H14.1498V17.95H12.0498C11.3831 17.95 10.7498 17.6833 10.2831 17.2167C9.81647 16.75 9.5498 16.1167 9.5498 15.45V4.61668C9.5498 3.95001 9.81647 3.31668 10.2831 2.85001C10.7498 2.38335 11.3831 2.11668 12.0498 2.11668H14.1498V2.08335Z",
    fill: "#404349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 15.0167V20.0167H13.75V15.0167H18.75ZM17.8833 19.1833V15.85H14.55V19.1833H17.8833Z",
    fill: "#404349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 0.0166626V5.01666H13.75V0.0166626H18.75ZM17.8833 4.18333V0.849996H14.55V4.18333H17.8833Z",
    fill: "#404349"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_2521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgChart);
export default __webpack_public_path__ + "static/media/org-chart.51d49596ecc298e27b48d461951ae908.svg";
export { ForwardRef as ReactComponent };